var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3732",
    fillRule: "evenodd",
    d: "M8.427 8a.71.71 0 0 0-.08-.32L.747.08C.693.027.6 0 .467 0c-.134 0-.24.04-.32.12C.067.2.04.293.067.4c.026.107.066.213.12.32L7.467 8l-7.28 7.28c-.107.107-.16.213-.16.32 0 .107.04.2.12.28.08.08.186.12.32.12.133 0 .226-.027.28-.08l7.6-7.6a.71.71 0 0 0 .08-.32z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronIcon);
export default __webpack_public_path__ + "static/media/chevron_icon.3d9e5d9d0c603aecd3da3a9e6981e328.svg";
export { ForwardRef as ReactComponent };